import { render, staticRenderFns } from "./InvestorBankItem.vue?vue&type=template&id=07f13bac&scoped=true&"
import script from "./InvestorBankItem.vue?vue&type=script&lang=js&"
export * from "./InvestorBankItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestorBankItem.vue?vue&type=style&index=0&id=07f13bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f13bac",
  null
  
)

export default component.exports